import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { forkJoin, Observable, switchMap } from 'rxjs';
import { ContextDump, Metrics } from '../models/metrics';

@Injectable({
  providedIn: 'root',
})
export class MetricsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/v1`;

  getMetrics(): Observable<Metrics[]> {
    const metricsEndpoint = `${this.apiUrl}/metrics`;
    return this.http
      .get<{ rooms: string[] }>(metricsEndpoint)
      .pipe(
        switchMap(({ rooms }) =>
          forkJoin(
            rooms.map((roomName) => this.http.get<Metrics>(`${metricsEndpoint}/${roomName}`)),
          ),
        ),
      );
  }

  /**
   * Fetches the current AI context dump for a given room.
   * Returns 404 when no context has been pushed yet.
   */
  getContext(roomName: string): Observable<ContextDump> {
    return this.http.get<ContextDump>(`${this.apiUrl}/context/${encodeURIComponent(roomName)}`);
  }
}
